/* Cânon Nissi — WhatsApp Modal no Carrinho (tag: encomendar)

  Objetivo:
  - Quando existir item com tag "encomendar" no carrinho, o checkout deve ser finalizado via WhatsApp.
  - O modal deve listar os itens e levar ao WhatsApp com a mensagem pronta.

  Observações:
  - Usa os modais renderizados pelo snippet: cn-whatsapp-mixed-modal.liquid
    - #cn-whatsapp-mixed-overlay (carrinho misto)
    - #cn-encomendar-overlay (somente encomenda)
*/
(function(){
  if(window.__CN_CART_WA_BOOTED) return;
  window.__CN_CART_WA_BOOTED = true;

  var isCartPage = /\/cart(\/|\?|$)/.test(location.pathname + location.search);
  if(!isCartPage) return;

  function q(sel, root){ return (root||document).querySelector(sel); }

  function getCartJSON(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
  }

  // Cache de tags por handle
  var tagCache = {};
  function getProductTags(handle){
    if(!handle) return Promise.resolve([]);
    if(tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(p){
        var tags = (p && p.tags) ? p.tags : [];
        tagCache[handle] = tags;
        return tags;
      })
      .catch(function(){ tagCache[handle] = []; return []; });
  }

  function deriveCartTags(cart){
    var items = (cart && cart.items) ? cart.items : [];

    // Mapear por handle e puxar tags
    return Promise.all(items.map(function(it){
      return getProductTags(it.handle).then(function(tags){
        var lower = (tags||[]).map(function(t){ return String(t||'').toLowerCase(); });
        // CORREÇÃO: este mapeamento só guardava title/quantity/handle, mas a
        // mensagem do WhatsApp usa product_title, variant_title, sku, price e
        // final_line_price. Resultado: a partir da página /cart a mensagem saía
        // sem variante, sem SKU e sem preços — mesmo em produtos que os têm.
        // Alinhado com o mapeamento do cn-whatsapp-drawer.js.
        return {
          title: it.title,
          product_title: it.product_title,
          variant_title: it.variant_title,
          sku: it.sku,
          price: it.price,
          final_line_price: it.final_line_price,
          quantity: it.quantity,
          handle: it.handle,
          isEncomendar: lower.indexOf('encomendar') !== -1
        };
      });
    })).then(function(list){
      var hasEnco = list.some(function(x){ return x.isEncomendar; });
      var hasAvailable = list.some(function(x){ return !x.isEncomendar; });
      return {
        items: list,
        hasEnco: hasEnco,
        isMixed: hasEnco && hasAvailable
      };
    });
  }

  function fmtEurWA(c){ if(c == null || isNaN(c)) return ''; return '€' + (Number(c)/100).toFixed(2).replace('.', ','); }

  // Linhas detalhadas, iguais às do formulário de encomenda: variante, SKU,
  // quantidade, preço unitário e subtotal.
  function linhasWA(items){
    var totalCents = 0;
    var linhas = (items||[]).map(function(it){
      var nome = it.product_title || it.title || 'Produto';
      var variante = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var qty = it.quantity || 1;
      var unit = fmtEurWA(it.price);
      var sub  = fmtEurWA(it.final_line_price != null ? it.final_line_price : (it.price||0)*qty);
      if(it.final_line_price != null) totalCents += Number(it.final_line_price);
      else if(it.price != null) totalCents += Number(it.price) * qty;
      var l = '• ' + nome;
      if(variante) l += '\n   - Variante: ' + variante;
      if(it.sku) l += '\n   - SKU: ' + it.sku;
      l += '\n   - Qtd: ' + qty + (unit ? ' × ' + unit : '') + (sub ? ' = ' + sub : '');
      return l;
    }).join('\n');
    return linhas + (totalCents > 0 ? '\nTotal: ' + fmtEurWA(totalCents) : '');
  }

  function buildWhatsHref(items, mode){
    var phone = '351913767399';
    var msg = mode === 'mixed'
      ? 'Olá! Adicionei estes produtos ao carrinho:\n' + linhasWA(items) +
        '\n\nHá itens com prazos diferentes no carrinho. Pode ajudar-me a finalizar corretamente?'
      : 'Olá! Gostaria de encomendar estes produtos:\n' + linhasWA(items) +
        '\n\nEstes itens são feitos por encomenda e podem ter prazo maior. Pode ajudar-me a finalizar?';
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
  }

  // Botão "Continuar comprando" (mesma assinatura usada no snippet)
  window.cnw_continue_shopping = function(ev){
    try{ if(ev){ ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation(); } }catch(e){}
    try{ var a=document.getElementById('cn-whatsapp-mixed-overlay'); if(a) a.classList.remove('cnw-open'); }catch(e){}
    try{ var b=document.getElementById('cn-encomendar-overlay'); if(b) b.classList.remove('cnw-open'); }catch(e){}
    try{ document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open'); }catch(e){}
    // Preferir voltar para a página anterior (normalmente coleção/produto)
    try{
      if(document.referrer && document.referrer.indexOf(location.origin) === 0){ window.location.href = document.referrer; }
      else { window.location.href = '/collections/all'; }
    }catch(e){ window.location.href = '/collections/all'; }
  };

  function openMixed(items){
    var ov = q('#cn-whatsapp-mixed-overlay');
    if(!ov) return false;

    var box = q('#cnw-items');
    if(box){
      var ul = document.createElement('ul');
      (items||[]).forEach(function(it){
        var li = document.createElement('li');
        li.textContent = (it.title||'Produto') + ' x' + (it.quantity||1);
        ul.appendChild(li);
      });
      box.innerHTML = '';
      box.appendChild(ul);
    }

    var wa = q('#cnw-whatsapp');
    if(wa){ wa.href = buildWhatsHref(items, 'mixed'); }

    function close(){
      ov.classList.remove('cnw-open');
      document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open');
    }

    var closeBtn = q('.cnw-close', ov);
    if(closeBtn){ closeBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); close(); }, {once:true, capture:true}); }
    ov.addEventListener('click', function(e){ if(e.target === ov) close(); }, {capture:true});

    ov.classList.add('cnw-open');
    document.body.classList.add('cnw-modal-open'); document.documentElement.classList.add('cnw-modal-open');
    return true;
  }

  function openEncomendar(items){
    var ov = q('#cn-encomendar-overlay');
    if(!ov) return false;

    var box = q('#cne-items', ov);
    if(box){
      var ul = document.createElement('ul');
      (items||[]).forEach(function(it){
        var li = document.createElement('li');
        li.textContent = (it.title||'Produto') + ' x' + (it.quantity||1);
        ul.appendChild(li);
      });
      box.innerHTML = '';
      box.appendChild(ul);
    }

    // CORREÇÃO: #cne-whatsapp é um <button>, não um <a>. A versão anterior
    // fazia `wa.href = ...`, o que num botão não faz nada — o "ENCOMENDAR
    // AGORA" ficava morto na página do carrinho. Agora abre o formulário de
    // encomenda, tal como já acontecia na PDP e no cart drawer.
    var currentItems = items || [];
    var form     = q('#cne-form', ov);
    var introPs  = ov.querySelectorAll('.cnw-body > p');
    var itemsBox = q('#cne-items', ov);
    var footer   = ov.querySelector('.cnw-footer');
    var btnWA    = q('#cne-whatsapp', ov);
    var btnBack  = q('#cne-form-back', ov);
    var titleEl  = q('#cne-title', ov);

    function showInitial(){
      if(form) form.hidden = true;
      Array.prototype.forEach.call(introPs, function(p){ p.style.display = ''; });
      if(itemsBox) itemsBox.style.display = '';
      if(footer) footer.style.display = '';
      if(titleEl) titleEl.textContent = 'Produto temporariamente esgotado!';
    }
    function showForm(){
      Array.prototype.forEach.call(introPs, function(p){ p.style.display = 'none'; });
      if(itemsBox) itemsBox.style.display = 'none';
      if(footer) footer.style.display = 'none';
      if(titleEl) titleEl.textContent = 'Dados para a encomenda';
      if(form) form.hidden = false;
    }
    showInitial();
    if(form) form.reset();

    if(btnWA){ btnWA.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); showForm(); }; }
    if(btnBack){ btnBack.onclick = function(ev){ ev.preventDefault(); ev.stopPropagation(); showInitial(); }; }

    if(form){
      form.onsubmit = function(ev){
        ev.preventDefault();
        if(typeof form.checkValidity === 'function' && !form.checkValidity()){
          if(typeof form.reportValidity === 'function') form.reportValidity();
          return false;
        }
        var fd = new FormData(form);
        function v(n){ return String(fd.get(n) || '').trim(); }
        function fmtEur(c){ if(c == null || isNaN(c)) return ''; return '€' + (Number(c)/100).toFixed(2).replace('.', ','); }
        var totalCents = 0;
        var lines = currentItems.map(function(it){
          var name = it.product_title || it.title || 'Produto';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
          var qty = it.quantity || 1;
          var unit = fmtEur(it.price);
          var sub  = fmtEur(it.final_line_price != null ? it.final_line_price : (it.price||0)*qty);
          if(it.final_line_price != null) totalCents += Number(it.final_line_price);
          else if(it.price != null) totalCents += Number(it.price) * qty;
          var l = '• ' + name;
          if(variant) l += '\n   - Variante: ' + variant;
          if(it.sku) l += '\n   - SKU: ' + it.sku;
          l += '\n   - Qtd: ' + qty + (unit ? ' × ' + unit : '') + (sub ? ' = ' + sub : '');
          return l;
        }).join('\n');
        var totalLine = totalCents > 0 ? ('\nTotal: ' + fmtEur(totalCents)) : '';
        var msg =
          'Olá! Gostaria de encomendar:\n' + lines + totalLine + '\n\n' +
          'Dados para encomenda:\n' +
          'Nome: ' + v('nome') + '\n' +
          'Telefone: ' + v('telefone') + '\n' +
          'E-mail: ' + v('email') + '\n' +
          'NIF: ' + v('nif') + '\n' +
          'Morada: ' + v('morada') + '\n' +
          'Código Postal: ' + v('cp') + '\n' +
          'Freguesia: ' + v('freguesia') + '\n' +
          'Distrito: ' + v('distrito');
        var href = 'https://wa.me/351913767399?text=' + encodeURIComponent(msg);
        try { window.open(href, '_blank', 'noopener'); }
        catch(e){ window.location.href = href; }
        close();
        return false;
      };
    }

    function close(){
      ov.classList.remove('cnw-open');
      document.body.classList.remove('cnw-modal-open'); document.documentElement.classList.remove('cnw-modal-open');
      showInitial();
      if(form) form.reset();
    }

    var closeBtn = q('.cne-close', ov);
    if(closeBtn){ closeBtn.onclick = function(e){ e.preventDefault(); e.stopPropagation(); close(); }; }
    var cont = q('#cne-continue', ov);
    if(cont){ cont.onclick = function(e){ e.preventDefault(); e.stopPropagation(); close(); }; }
    ov.onclick = function(e){ if(e.target === ov) close(); };

    ov.classList.add('cnw-open');
    document.body.classList.add('cnw-modal-open'); document.documentElement.classList.add('cnw-modal-open');
    return true;
  }

  // Interceptar finalização do carrinho
  function interceptCheckout(){
    var selectors = [
      'form[action="/checkout"]',
      'button[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      'a[href="/checkout"]',
      'a[href^="/checkout?"]'
    ];

    document.addEventListener('click', function(ev){
      var el = ev.target;
      var matched = null;
      for(var i=0;i<5 && el;i++, el=el.parentElement){
        for(var s=0;s<selectors.length;s++){
          if(el.matches && el.matches(selectors[s])){ matched = el; break; }
        }
        if(matched) break;
      }
      if(!matched) return;

      // Não interferir em botões de pagamento express (Shop Pay, Apple Pay etc.)
      var txt = (matched.textContent||'').trim().toLowerCase();
      if(txt.includes('shop pay') || txt.includes('apple') || txt.includes('google') || matched.getAttribute('data-shop-pay') ){
        return;
      }

      // Avalia carrinho e decide
      ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();

      getCartJSON()
        .then(deriveCartTags)
        .then(function(res){
          if(!res.hasEnco){
            // Sem encomenda: seguir fluxo normal
            window.location.href = '/checkout';
            return;
          }
          if(res.isMixed){ openMixed(res.items); }
          else { openEncomendar(res.items); }
        })
        .catch(function(){
          // fallback: se falhar, segue checkout
          window.location.href = '/checkout';
        });
    }, true);

    document.addEventListener('submit', function(ev){
      var form = ev.target;
      if(!form || !form.getAttribute) return;
      if((form.getAttribute('action')||'').toLowerCase() !== '/checkout') return;

      ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();

      getCartJSON()
        .then(deriveCartTags)
        .then(function(res){
          if(!res.hasEnco){ window.location.href = '/checkout'; return; }
          if(res.isMixed){ openMixed(res.items); }
          else { openEncomendar(res.items); }
        })
        .catch(function(){ window.location.href = '/checkout'; });
    }, true);
  }

  interceptCheckout();
})();
